import React, { useState, useRef, useEffect } from "react";
import classNames from "classnames/bind";

import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import SwiperCore, { Pagination, Navigation, Autoplay } from "swiper";

// component
import LightBox from "src/components/common/LightBox/LightBox";

// assets
import PlaceholderImg from "src/assets/images/home/gradient.png";
import { AiOutlineFullscreen } from "react-icons/ai";

// styles
import styles from "../styles.module.scss";
const cx = classNames.bind(styles);

SwiperCore.use([Pagination, Navigation, Autoplay]);

const ImageSlider = ({ data }) => {
  const [imgError, setImgError] = useState(false);
  const [gallery, setGallery] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  const [images, setImages] = useState([]);

  const swiperRef = useRef(null);

  useEffect(() => {
    if (data) {
      setGallery(data?.ImageUrls || []);
    }
  }, [data]);

  useEffect(() => {
    if (gallery.length === 1) {
      swiperRef.current.swiper.autoplay.stop();
    }
  }, [gallery]);

  const isExist = () => {
    if (data.ImageUrls) {
      if (data?.ImageUrls?.length > 0 && data?.ImageUrls?.[0] !== "")
        return true;
    }

    return false;
  };

  const onImgError = (_index) => {
    let newGallery = gallery.map((item, i) =>
      i === _index ? PlaceholderImg : item
    );

    setGallery(newGallery);
  };

  const openLightBox = () => {
    if (gallery.length > 0) {
      setImages(gallery);
    } else {
      let img_path = !imgError ? data.Image : PlaceholderImg;

      setImages([img_path]);
    }

    setIsOpen(true);
  };

  return (
    <div className={cx("image-slider")}>
      {gallery.length > 0 && (
        <Swiper
          ref={swiperRef}
          navigation={false}
          centeredSlides={true}
          freeMode={true}
          slidesPerView="auto"
          preloadImages
          pagination={{ clickable: true }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          breakpoints={{
            576: {
              freeMode: false,
            },
          }}
        >
          {!isExist() ? (
            <SwiperSlide>
              <img
                src={!imgError ? data?.Image : PlaceholderImg}
                alt="event_details"
                className={cx("slider-image")}
                onError={() => setImgError(true)}
              />
            </SwiperSlide>
          ) : (
            <>
              {gallery?.map((item, i) => (
                <SwiperSlide key={i}>
                  <img
                    src={item}
                    alt="event_details"
                    className={cx("slider-image")}
                    onError={() => onImgError(i)}
                  />
                </SwiperSlide>
              ))}
            </>
          )}
        </Swiper>
      )}
      <span className={styles.icon} onClick={openLightBox}>
        <AiOutlineFullscreen />
      </span>
      <LightBox images={gallery} isOpen={isOpen} setIsOpen={setIsOpen} />
    </div>
  );
};

export default ImageSlider;
